export { default } from './FooterTrustLogos'
